import React, { Component } from 'react'
import './styles.css'
import {
  defineMessages,
  FormattedMessage,
  injectIntl
} from 'react-intl'
import Modal from 'components/Modal'
import Button from 'components/Button'
import { MS_IN_SEC } from 'constants/dateTime'
import Icon from 'components/icons'
import queryString from 'query-string'
import { sendGAClickEvent } from 'utils/googleAnalytics'
import { isRemoteVisitor, isAndroid } from 'utils/user'
import FormattedCurrency from 'components/FormattedCurrency'

const messages = defineMessages({
  title: 'Thank you for visiting!',
  close: 'Close',
  billingTitle: 'Your Bill',
  callTime: 'Call Time',
  minutesPluralized: `{minutes, number} {minutes, plural, one {minute} other {minutes}}`,
  ratePerMinute: 'Cost per minute',
  free: 'Free',
  couponMinutes: 'Coupon Used',
  helpUs: 'How was your call quality?',
  moreFeedBack: 'More Feedback',
  feedbackPlaceholder: 'Please leave additional feedback here...',
  suggestDeposit: 'Would you like to make a deposit?',
  depositButtonText: 'Deposit Now'
})

export class VisitEndedModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showFeedbackInput: false,
      timerId: 0,
      feedback: '',
      rating: 0
    }
    this.setTimer = this.setTimer.bind(this)
    this.onClose = this.onClose.bind(this)
    this.onFeedBackChange = this.onFeedBackChange.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.setTimer()
    }
  }

  setTimer() {
    if (this.state.timerId) {
      clearTimeout(this.state.timerId)
    }
    const timerId = setTimeout(this.onClose, 30 * MS_IN_SEC)
    this.setState({ timerId })
  }

  onFeedBackChange(e) {
    this.setTimer()
    this.setState({ feedback: e.target.value})
  }

  onClose() {
    const {
      closeModal,
      redirectURL,
      sendFeedback
    } = this.props

    sendFeedback(this.state.rating, this.state.feedback)
    closeModal()
    clearTimeout(this.state.timerId)
    if (redirectURL) {
      window.location.replace(redirectURL)
    }
  }

  buildDepositPageURL(residentId, locale) {
    const depositInmateId = residentId * 17
    return `${process.env.TELMATE_PAY_URL}/state/deep_inmate?deposit_inmate_id=${depositInmateId}&locale=${locale}`
  }

  openURLInAndroidBrowser(url) {
    if (window.TelmateJSInterface && window.TelmateJSInterface.openURL) {
      window.TelmateJSInterface.openURL(url)
      return true
    }
    return false
  }

  render() {
    const {
      show,
      totalMinutes,
      rate,
      amountCharged,
      couponMinutes,
      intl
    } = this.props

    const queryParams = queryString.parse(location.hash.split('?')[1])

    const {
      resident_id: residentId,
      show_post_visit_deposit: showPostVisitDeposit,
      locale
    } = queryParams

    const showBillingInfo = amountCharged || couponMinutes

    // do not show "Deposit Now" button if TELMATE_PAY_URL is not specified
    const depositSectionIsAvailable = showPostVisitDeposit === 'true' && process.env.TELMATE_PAY_URL
    const showDeposit = depositSectionIsAvailable && isRemoteVisitor()
    const depositPageURL = this.buildDepositPageURL(residentId, locale)

    return (
      <Modal
        title={(<FormattedMessage {...messages.title} />)}
        show={show}
        footer={(
          <Button
            type='ok'
            onClick={() => {
              sendGAClickEvent('CTA_Close_Visit_Modal')
              this.onClose()
            }}
            id='CTA_Close_Visit_Modal'
          >
            <FormattedMessage {...messages.close} />
          </Button>
        )}
      >
        <div styleName='visitDetails'>
          <table styleName='billingInfo'>
            { !!totalMinutes && (
              <tr>
                <th>
                  <FormattedMessage {...messages.callTime} />:
                </th>
                <td>
                  <FormattedMessage {...messages.minutesPluralized} values={{ minutes: totalMinutes }} />
                </td>
              </tr>
            )}

            { showBillingInfo && rate && (
              <tr>
                <th>
                  <FormattedMessage {...messages.ratePerMinute} />:
                </th>
                { rate > 0 && (
                  <td>
                    <FormattedCurrency value={rate / 100} />
                  </td>
                )}
                { rate <= 0 && (
                  <td>
                    <FormattedMessage {...messages.free} />
                  </td>
                )}
              </tr>
            )}

            { showBillingInfo && !couponMinutes && (
              <tr>
                <th>
                  <FormattedMessage {...messages.billingTitle} />:
                </th>
                { rate > 0 && amountCharged && (
                  <td>
                    <FormattedCurrency value={amountCharged / 100} />
                  </td>
                )}
                { rate <= 0 && (
                  <td>
                    <FormattedMessage {...messages.free} />
                  </td>
                )}
              </tr>
            )}

            { showBillingInfo && !!couponMinutes && (
              <tr>
                <th>
                  <FormattedMessage {...messages.billingTitle} />:
                </th>
                <td>
                  <FormattedMessage {...messages.couponMinutes} />
                </td>
              </tr>
            )}
          </table>

          { showDeposit && (
            <div styleName='deposit'>
              <h4 styleName='depositText'><FormattedMessage {...messages.suggestDeposit} /></h4>
              <Button
                type='go'
                onClick={() => {
                  sendGAClickEvent('CTA_Post_Visit_Deposit')
                  if (isAndroid() && this.openURLInAndroidBrowser(depositPageURL)) {
                    return
                  }
                  window.open(depositPageURL,'_blank')
                }}
                id='CTA_Post_Visit_Deposit'
              >
                <FormattedMessage {...messages.depositButtonText} />
              </Button>
            </div>
          )}

          <div styleName='ratingAndFeedback' data-ng-click="rating.updateLogoutTimer()">
            <h4 styleName='feedbackHeader'><FormattedMessage {...messages.helpUs} /></h4>
            <ul styleName='stars'>
              <li styleName='starWrapper' onClick={() => this.setState({ rating: 1})}><Icon name={this.state.rating < 1 ? 'star' : 'star-filled'} width={54} /></li>
              <li styleName='starWrapper' onClick={() => this.setState({ rating: 2})}><Icon name={this.state.rating < 2 ? 'star' : 'star-filled'} width={54} /></li>
              <li styleName='starWrapper' onClick={() => this.setState({ rating: 3})}><Icon name={this.state.rating < 3 ? 'star' : 'star-filled'} width={54} /></li>
              <li styleName='starWrapper' onClick={() => this.setState({ rating: 4})}><Icon name={this.state.rating < 4 ? 'star' : 'star-filled'} width={54} /></li>
              <li styleName='starWrapper' onClick={() => this.setState({ rating: 5})}><Icon name={this.state.rating < 5 ? 'star' : 'star-filled'} width={54} /></li>
            </ul>
            {!this.state.showFeedbackInput && (
              <a styleName='moreFeedbackText'
                 onClick={() => {
                   sendGAClickEvent('CTA_More_Feedback')
                   this.setState({showFeedbackInput: true})
                 }}
                 id='CTA_More_Feedback'>
                <FormattedMessage {...messages.moreFeedBack} />
              </a>
            )}
            {this.state.showFeedbackInput && (
              <label>
                <textarea
                  cols={60}
                  rows={10}
                  styleName='feedbackInputbox'
                  placeholder={intl.formatMessage(messages.feedbackPlaceholder)}
                  maxLength={2048}
                  onChange={this.onFeedBackChange}
                />
              </label>
            )}
          </div>
        </div>
      </Modal>
    )
  }
}

export default injectIntl(VisitEndedModal)
